/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
import { useDispatch, useSelector } from 'react-redux';
import mbpLogger from '@module-logger/mbp';
import { useEffect } from 'react';
import { getFeatureFlag } from '../../../../state/ducks/App/ducks/Config/Config-Selectors';
import { getBrandName } from '../../../../state/ducks/App/ducks/Brand/Brand-Selectors';

import useSalesforcePersonalizedContentQuery from '../useSalesforcePersonalizedContentQuery';
import { setRedirectTestFlag } from '../../../../state/ducks/App/App-Actions';

export const useAuthCallBackTest = () => {
    const dispatch = useDispatch();
    const ffIsAuthCallbackEnabled = useSelector(getFeatureFlag('is-auth-callback-enabled'));
    let isAuthCallbackEnabled = false;

    const brandName = useSelector(getBrandName) || '1800flowers';

    const interactionName = `${brandName} - Get Campaign - Personalized Landing Page`;
    const targeting = {
        pageType: 'home',
    };
    const {
        loading, error, data, variables,
    } = useSalesforcePersonalizedContentQuery({
        queryName: 'AuthCallbackTest',
        interactionName,
        targeting,
        optInHoldoutParticipation: true,
        resolveIdentity: false,
        featureFlag: ffIsAuthCallbackEnabled,
    });

    useEffect(() => {
        if (!loading && !error) {
            dispatch(setRedirectTestFlag(true));
        }
    }, []);
    if (loading || variables?.skip) {
        return null;
    }

    if (error) {
        mbpLogger.logError({
            function: 'AuthCallbackTest.js',
            message: 'Error loading data from PersonalizedContent API',
            appName: process.env.npm_package_name,
            module: 'Auth callback test',
            jsError: error,
        });
    }

    if (data?.contentSF) {
        const userGroup = data?.contentSF?.campaign?.campaignResponses?.[0]?.payload?.userGroup;
        isAuthCallbackEnabled = userGroup?.toLowerCase?.() === 'test';
        if (typeof window !== 'undefined' && window.sessionStorage) {
            window.sessionStorage.setItem('authCallBackSFData', data?.contentSF ? JSON.stringify(data?.contentSF) : '{}');
            window.sessionStorage.setItem('isAuthCallbackEnabled', isAuthCallbackEnabled);
        }
    }

    return isAuthCallbackEnabled;
};

export default useAuthCallBackTest;
